import React, { Component } from 'react';
import './AboutUs.css';
import { NavItem, NavLink, Nav } from 'reactstrap';
import { Link } from 'react-router-dom'

class AboutUs extends Component {

    constructor(props){
        super(props);
    }

    componentDidMount() {
        document.title = 'About Us';
    }

    render () {
          return (
            <div><div > 
                    <NavLink style={{position:'fixed', fontSize:'30px', padding:'15px 30px', color:'white', width:'100%', background: '#333F50'}} tag={Link} to={'/login'}>
                                                swipequotes
                                                </NavLink>
                </div>
                <div className="aboutUsContainer">
            <div className="aboutUsHeader"> About Us</div>
            <p>Swipe Quotes is our modest attempt to share the literary works of prominent individuals from across the world - words that offer bursts of wisdom, inspiration, insights and perspectives - to reinforce knowledge, influence or motivate us - or sometimes to find a voice that echos our thoughts and give us some direction.
            We're glad to have you here. We hope this space uplifts you and widens your awareness.
            </p>
          </div>
          <div className='aboutUsFooter'>
                    <Nav horizontal className="list-unstyled pb-3">
                        <NavItem>
                            <NavLink tag={Link} to={'/login'}>
                            Home
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/aboutUs'}>
                            About Us
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/termsOfService'}>
                            Terms of Service
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/privacyPolicy'}>
                            Privacy & Content Policy
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink tag={Link} to={'/questions'}>
                            Have Questions ?
                            </NavLink>
                        </NavItem>
                        <NavItem>
                        <NavLink tag={Link} to={'/connect'}>
                            Connect with Us
                        </NavLink>
                        </NavItem>
                    </Nav>
            </div>
        </div>
            
          )
    }
  }
  
  export default AboutUs